import { Link as InternalLink } from '@lessonnine/design-system.lib'
import { CURRENT_DS_VERSION } from 'src/dataLayer/localData/designSystem'
import { DS_VERSIONS } from 'src/dataLayer/localData/designSystem/versions'

const Link = {
  [DS_VERSIONS.default]: InternalLink,
}

export default Link[CURRENT_DS_VERSION]
